module.exports = __webpack_public_path__ + "img/arturo-de-la-fuente-byn.67fa60c7.jpg";